export default {
	COPSECANCOL_Actas_reunion: {
		oFirmas: {
			nFiltro: 'actareunionid',
			sAsistente: 'Nombre_Asistente',
			sFirma: 'Firma_Asistente',
			sTablaAnexos: 'COPSECANCOL_Asistentes_Acta_Reunion'
		},
		oFotos: {
			nFiltro: 'actareunionid',
			sAnexo: 'nombre_anexo',
			sTipoAnexo: 'tipo_anexo',
			sTablaAnexos: 'COPSECANCOL_Anexos_Acta_Reunion'
		}
	},
	ELEMENTOS_ElementosEntrada: {
		oFotos: {
			nFiltro: 'idActivo',
			sAnexo: 'NombreAnexo',
			sTipoAnexo: '',
			sTablaAnexos: 'ELEMENTOS_ActivosAnexos'
		}
	},
	COPSECANCOL_Actas_reunion$1:{
		oFirmas: {
			nFiltro: 'actareunionid',
			sAsistente: 'Nombre_Asistente',
			sFirma: 'Firma_Asistente',
			sTablaAnexos: 'COPSECANCOL_Asistentes_Acta_Reunion'
		},
	},
	COPSECANCOL_Actas_reunion$2: {
		oFirmas: {
			nFiltro: 'actareunionid',
			sAsistente: 'Nombre_Asistente',
			sFirma: 'Firma_Asistente',
			sTablaAnexos: 'COPSECANCOL_Asistentes_Acta_Reunion'
		},
		oFotos: {
			nFiltro: 'actareunionid',
			sAnexo: 'nombre_anexo',
			sTipoAnexo: 'tipo_anexo',
			sTablaAnexos: 'COPSECANCOL_Anexos_Acta_Reunion'
		}
	},
	COP_Administrativos: {
		oFotos: {
			nFiltro: 'administrativoid',
			sAnexo: 'Nombre_Anexo',
			sTipoAnexo: 'Tipo_Anexo',
			sTablaAnexos: 'COP_Anexos_Administrativo'
		}
	},
	COP_Rondas_Monitoreo: {
		oFotos: {
			nFiltro: 'rondasmonitoreoid',
			sAnexo: 'Nombre_Anexo',
			sTipoAnexo: 'Tipo_Anexo',
			sTablaAnexos: 'COP_Anexos_Rondas_Monitoreo'
		}
	},
	COP_Novedades_Operativas: {
		oFotos: {
			nFiltro: 'novedadoperativaid',
			sAnexo: 'Nombre_Anexo',
			sTipoAnexo: 'Tipo_Anexo',
			sTablaAnexos: 'COP_Anexos_Novedad_Operativa'
		}
	},
	PQR_Requerimientos: {
		oFotos: {
			nFiltro: 'requerimientoid',
			sAnexo: 'nombre',
			sTipoAnexo: 'idTipoAnexo',
			sTablaAnexos: 'V_PqrAnexosGenerales'
		}
	},
	COPSECANCOL_Compromisos_Historico: {
		oFotos: {
			nFiltro: 'compromisoid',
			sAnexo: 'Anexos',
			sTipoAnexo: 'Tipo',
			sTablaAnexos: 'COPSECANCOL_Compromisos_Historico'
		}
	},
	RiesgoNovedades: {
		oFotos: {
			nFiltro: 'novedadid',
			sAnexo: 'nombre_anexo',
			sTipoAnexo: 'tipo_anexo',
			sTablaAnexos: 'RiesgoAnexosNovedades'
		}
	},
	V_PQR_Gestion: {
		oFotos: {
			nFiltro: 'requerimientoid',
			sAnexo: 'nombre',
			sTipoAnexo: 'idTipoAnexo',
			sTablaAnexos: 'V_PqrAnexosGenerales'
		}
	},
}